import { ReactNode } from "react";
import { PermissionContext } from "./PermissionContext";
import { PermissionChecker } from "../../types/permission";

interface PermissionProviderProps {
  children: ReactNode;
  hasPermission: PermissionChecker;
}

export const PermissionProvider = ({
  children,
  hasPermission,
}: PermissionProviderProps) => {
  return (
    <PermissionContext.Provider value={{ hasPermission }}>
      {children}
    </PermissionContext.Provider>
  );
};
